<template>
  <div>
    <slot></slot>
    <TextInput :required="true" :disabled="data.fullcopy" @setError="errors.name = $event" v-model="data.name" text="ФИО Выгодоприобретателя" :name="`beneficiary-${index}-name`" @update:modelValue="suggestName($event)" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="data.name.split(' ').filter(el=>el.trim()).length >= 3" />
    <CheckBox v-if="copyEnabled || data.fullcopy" :name="`beneficiary-${index}-fullcopy`" v-model="data.fullcopy">Заявитель совпадает с&nbsp;выгодоприобритателем</CheckBox>
    <DateInput :required="true" :disabled="data.fullcopy" :validation="birthdateval" @setError="errors.birthdate = $event" :name="`beneficiary-${index}-birthdate`" text="Дата рождения Выгодоприобретателя" :range="false" v-model="data.birthdate" />
    <SelInput :required="true" :disabled="data.fullcopy" text="Документ удостоверяющий личность" :name="`beneficiary-${index}-doctype`" :options="doctypes" v-model="data.doc.type" />
    <ShortFields>
      <NumberInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.series" mask="####" @setError="errors.series = $event" :filled="(v) => v.length == 4" v-model="data.doc.series" text="Серия документа" :name="`beneficiary-${index}-doc-series`" />
      <NumberInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.number" mask="######" @setError="errors.number = $event" :filled="(v) => v.length == 6" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-number`" />
      <TextInput :maxlength="50" :validation="(v) => (v.length > 50) ? 'Не более 50 символов': ''" :required="true" :disabled="data.fullcopy" v-if="dynamicfields.foreignnumber" @setError="errors.number = $event" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-foreign-number`" />
    </ShortFields>
    <ShortFields>
      <NumberInput :forceError="CodeError" :required="true" :disabled="data.fullcopy" v-if="dynamicfields.code" mask="###-###" @setError="errors.code = $event" :filled="(v) => v.length == 7" v-model="data.doc.code" text="Код подразделения " :name="`beneficiary-${index}-doc-code`" />
      <DateInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.releasedate" @setError="errors.releasedate = $event" v-model="data.doc.releasedate" text="Дата выдачи документа" :name="`beneficiary-${index}-doc-releasedate`" />
    </ShortFields>
    <NumberInput mask="############" @setError="errors.INN = $event" :filled="(v) => v.length == 12 || !v.length" v-model="data.INN" text="ИНН Выгодоприобретателя" :name="`beneficiary-${index}-INN`" />
    <CheckBox :disabled="data.fullcopy" :name="`beneficiary-${index}-addresscopy`" v-model="data.addresscopy">Адрес проживания совпадает с адресом Заявителя</CheckBox>
    <TextInput :required="true" :alignRight="true" :forceError="(!data.fullcopy && data.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" :blurcondition="data.fullcopy ? undefined : addressIsCorrect" :disabled="data.addresscopy" @setError="errors.address = $event" :options="dadataVariants" v-model="data.address" text="Адрес проживания Выгодоприобретателя" :name="`beneficiary-${index}-address`" />
    <CheckBox :name="`beneficiary-${index}-publicPerson`" v-model="data.publicPerson">Является публичным должностным лицом</CheckBox>
    <SelInput text="Степень родства Заявителя с Застрахованным" :name="`beneficiary-${index}-relationship`" :options="relationships" v-model="data.relationship" />
    <CheckBox :name="`beneficiary-${index}-insuredperson-is-beneficiary`" v-model="data.insuredperson.copy">Застрахованный совпадает с&nbsp;выгодоприобритателем</CheckBox>
    <TextInput :required="true" :disabled="data.insuredperson.copy" @setError="errors.insuredname = $event" v-model="data.insuredperson.name" text="ФИО Застрахованного" :name="`beneficiary-${index}-insuredperson-name`" @update:modelValue="suggestName($event)" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="data.insuredperson.name.split(' ').filter(el=>el.trim()).length >= 3" />
    <DateInput :validation="birthdateval" :required="true" :disabled="data.insuredperson.copy" @setError="errors.insuredbirthdate = $event" :name="`beneficiary-${index}-insuredperson-birthdate`" text="Дата рождения Застрахованного" :range="false" v-model="data.insuredperson.birthdate" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import ShortFields from '../ShortFields.vue';
import NumberInput from '../inputs/NumberInput.vue';
import dadataSuggest from '@/mixins/dadataSuggest.js';
import CheckBox from '../inputs/CheckBox.vue';
import nameSuggest from '../../mixins/nameSuggest';
import birthdateValidation from '../../mixins/birthdateValidation';
export default {
  components: { TextInput, DateInput, SelInput, ShortFields, NumberInput, CheckBox },
  mixins: [dadataSuggest, nameSuggest, birthdateValidation],
  props: {
    copyEnabled: { type: Boolean, default: true },
    index: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  data: () => ({
    suggestionSuccess: false,
    timer: undefined,
    relationships: ['', 'Супруг/Супруга', 'Сын/Дочь', 'Отец/Мать', 'Другое'],
    doctypeindex: 0,
    errors: {},
    doctypes: ['', 'Паспорт гражданина РФ', 'Паспорт иностранного гражданина', 'Иное'],
    dadataVariants: [],
    data: {
      name: '',
      fullcopy: false,
      addresscopy: false,
      birthdate: '',
      doc: {
        type: '',
        series: '',
        number: '',
        code: '',
        code_info: '',
        releasedate: ''
      },
      address: '',
      INN: '',
      publicPerson: false,
      relationship: '',
      insuredperson: {
        copy: false,
        name: '',
        birthdate: ''
      },
    },
    dynamicfields: {
      series: false,
      number: false,
      foreignnumber: false,
      code: false,
      releasedate: false
    }
  }),
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (!this.data.name || !this.data.birthdate || !this.data.doc.type)
        return false
      let required = []
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key])
          if (key == 'foreignnumber')
            required.push('number')
          else
            required.push(key)

      for (let key of required) {
        if (!this.data.doc[key])
          return false
        if (key == 'code' && this.CodeError)
          return false
      }
      if (!this.data.addresscopy && !this.addressIsCorrect)
        return false
      if (!this.data.insuredperson.name || !this.data.insuredperson.birthdate) return false 
      return true
    },
    CodeError() {
      let code = this.data.doc.code
      if (!this.dynamicfields.code || !code || code.length != 7) return ''
      switch (this.suggestionSuccess) {
        case false:
          return 'Ошибка проверки кода'
        case 'error':
          return 'Неверный код подразделения'
        case 'request_wait':
          return 'Ожидание проверки кода...'
        case 'request_sended':
          return 'Идёт проверка кода...'
        case true:
          return ''
        default:
          return ''
      }
    },
    addressIsCorrect() {
      if (!this.dadataVariants.includes(this.data.address))
        return false
      else {
        let option = this.fullDadataSuggest.find(el => el.value == this.data.address)
        if (!option || !option.data.house || !option.data.house_kladr_id) return false
        return true
      }
    },
  },
  methods: {
    clearFields() {
      this.data.name = ''
      this.data.birthdate = ''
      this.data.doc.type = ''
      this.data.doc.series = ''
      this.data.doc.number = ''
      this.data.doc.code = ''
      this.data.doc.releasedate = ''
    },
    clearDynamicFields() {
      if (this.data.fullcopy) return
      this.data.doc.number = ''
      this.data.doc.series = ''
      this.data.doc.code = ''
      this.data.doc.releasedate = ''
    },
    setDynamicFields(doctypeindex) {
      this.doctypeindex = doctypeindex

      switch (doctypeindex) {
        case 1:
          return this.dynamicfields = {
            series: true,
            number: true,
            foreignnumber: false,
            code: true,
            releasedate: true
          }
        case 2:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: true,
            code: false,
            releasedate: true
          }
        case 0:
        case 3:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: false,
            code: false,
            releasedate: false
          }
      }
    },
    copyAddress() {
      this.data.address = this.form.applicant.address
    },
    copyAll() {
      this.data.name = this.form.applicant.name
      this.data.birthdate = this.form.applicant.birthdate
      this.data.doc.type = this.form.applicant.doc.type
      this.data.doc.series = this.form.applicant.doc.series
      this.data.doc.number = this.form.applicant.doc.number
      this.data.doc.code = this.form.applicant.doc.code
      this.data.doc.releasedate = this.form.applicant.doc.releasedate
      this.data.addresscopy = true
    },
    async checkCode(code) {
      this.suggestionSuccess = 'request_sended'
      let res = await this.$store.dispatch('suggestCodeLocation', code)
      this.data.doc.code_info = res
      if (res === false)
        return this.suggestionSuccess = false
      if (res && Array.isArray(res)) {
        if (res.length)
          return this.suggestionSuccess = true
        else
          return this.suggestionSuccess = 'error'
      }
      return this.suggestionSuccess = false
    }
  },
  watch: {
    'data.doc.type': function (value, old) {
      if (value != old)
        this.clearDynamicFields()
      for (let i = 0; i < this.doctypes.length; i++)
        if (value == this.doctypes[i])
          return this.setDynamicFields(i)
    },
    'data.insuredperson.copy': function(v) {
      if (v) {
        this.data.insuredperson.name = this.data.name
        this.data.insuredperson.birthdate = this.data.birthdate
      } else {
        this.data.insuredperson.name = ''
        this.data.insuredperson.birthdate = ''
      }
    },
    'data.name': function (value) {
      if (this.data.insuredperson.copy)
        this.data.insuredperson.name = value
    },
    'data.birthdate': function (value) {
      if (this.data.insuredperson.copy)
        this.data.insuredperson.birthdate = value
    },
    filled(v, old) {
      if (v != old)
        this.$emit('filledChanged', v)
    },
    data: {
      handler(v) {
        this.$emit('dataChanged', v)
      },
      deep: true
    },
    'data.address': async function (val) {
      if (this.data.addresscopy) return
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => this.dadataVariants = await this.dadataSuggest(val), 200)
    },
    'data.fullcopy': function (val) {
      if (val) {
        this.copyAll()
        this.$emit('setCopy', true)
      }
      else {
        this.$emit('setCopy', false)
        this.data.addresscopy = false
        this.clearFields()
      }
    },
    'data.addresscopy': function (val) {
      if (val)
        this.copyAddress()
      else
        this.data.address = ''
    },
    'data.doc.code': async function (code) {
      if (!code || code.length != 7) return this.suggestionSuccess = false
      if (!this.timer) {
        this.checkCode(code)
        this.timer = setTimeout(() => this.timer = undefined, 500)
      }
      else {
        this.suggestionSuccess = 'request_wait'
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.checkCode(code)
          this.timer = undefined
        }, 500)
      }
    },
    active() {
      if (this.data.fullcopy)
        this.copyAll()
      if (this.data.addresscopy)
        this.copyAddress()
    }

  }
}
</script>

<style lang="sass">
.step4block-additional
  position: relative
  &::before 
    content: ''
    position: absolute
    transition: background-color .3s ease-out
    left: -15px
    right: -15px
    bottom: -15px
    top: -15px
    border-radius: 10px
  &__close
    position: absolute
    top: -8px
    right: -8px
    z-index: 5
    width: 20px
    height: 20px
    cursor: pointer
    opacity: 0
    color: black
    transition: opacity .3s ease-out
    svg
      width: 100%
      display: block
  &:hover::before
    background-color: rgba(0,0,0,.05)
  &:hover &__close
    opacity: 1

</style>